<!--
 * @Author: DY
 * @Date: 2024-10-28 17:18:21
 * @LastEditTime: 2025-03-20 19:48:49
 * @Description:
 * @FilePath: \ShiMo_Mobile\src\views\home\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="home">
            <div class="homeHeader">
                <button type="button" @click="returnHomePage">
                    <span>{{ tatleText }}</span>
                </button>
            </div>
            <van-grid :gutter="25" :column-num="3" :border="false" :class="{ 'noneMenu': menuData.length == 0 }">
                <van-grid-item v-for="item in menuData" :key="item.id" :text="item.name" @click="openNav(item)">
                    <img :src="loadMenuImg(item)">
                    <p>{{ item.name }}</p>
                </van-grid-item>
                <van-button class="refresh" v-if="menuData.length < 1" @click="refresh">
                    刷新
                </van-button>
            </van-grid>
        </div>
    </v-touch>
</template>

<script>
export default {
    // 主页——采购
    name: 'home',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/mainMenu') {
            this.$store.commit('noKeepAlive', 'home');
        }
        next();
    },
    data() {
        return {
            tatleText: '',
            menuCode: '',
            // 菜单色块数据
            menuData: [],
        };
    },
    computed: {},
    watch: {},
    activated() {},
    created() {
        this.$toast.loading({ overlay: true, duration: 0 });
        this.tatleText = this.$route.params.date.name;
        this.menuCode = this.$route.params.date.code;
        // 获取色块数据
        this.homeInit();
    },
    mounted() { },
    destroyed() { },
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        returnHomePage() {
            this.$router.isBack = 1;
            this.$router.replace({ path: 'mainMenu' });
        },
        openNav(data) {
            this.$router.isBack = 2;
            const newQuery = {};
            if (data.query.length > 0) {
                data.query.forEach(item => {
                    newQuery[item] = true;
                });
            }
            this.$router.push({
                path: data.path,
                query: newQuery,
            });
        },
        loadMenuImg(item) {
            let src = '';
            if (item.css) {
                try {
                    src = require(`@/assets/images/home/${this.menuCode}/${item.css}.png`);
                } catch (e) {
                    src = require('@/assets/images/home/m_zw.png');
                }
            } else {
                src = require('@/assets/images/home/m_zw.png');
            }
            return src;
        },

        // 获取色块数据
        homeInit() {
            this.$axios
                .get(`/interfaceApi/basicplatform/usermenu?code=${this.menuCode}`)
                .then(res => {
                    if (res.userMenus.length > 0) {
                        res.userMenus[0].children.forEach(item => {
                            item.query = [];
                            if (item.path !== '') {
                                const strs = item.path.split('?');
                                item.path = strs[0];
                                if (strs.length > 1) {
                                    if (strs[1].indexOf('=') !== -1) {
                                        item.path = strs[0] + '?' + strs[1];
                                    } else {
                                        item.query.push(strs[1]);
                                    }
                                }
                                this.menuData.push(item);
                            }
                        });
                    }
                }).catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                }).finally(() => {
                    this.$toast.clear();
                });
        },
        refresh() {
            this.$toast.loading({ overlay: true, duration: 0 });
            this.menuData = [];
            this.homeInit();
        },
    },
};
</script>
<style lang="stylus">
.home
    height 100%
    background #fff
    padding-top 190rpx
    position: relative
    background: url(./../../assets/images/home/banner.png) no-repeat
    background-size: 100% 270rpx
    .homeHeader
        width 100%
        position: absolute
        top 37rpx
        padding 0 15rpx 0 26rpx
        display: flex
        justify-content: space-between
        align-items end
        button
            border none
            height: 28rpx
            &:first-child
                color #7B5313
                font-size 16rpx
                position: relative
                padding: 0 15rpx 0 25rpx
                font-family: BDZYJT
                border-radius: 0 14rpx 14rpx 0
                background: rgba(255, 255, 255, 0.2)
                span
                    font-weight: bold;
                    letter-spacing: 2px;
                    background-image: linear-gradient(180deg, #FFE3BD 0%, #C0934E 100%)
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                &:before
                    content ''
                    position: absolute
                    left -14rpx
                    top -2rpx
                    width 32rpx
                    height 32rpx
                    background: url(./../../assets/images/home/home.png) center no-repeat, #000
                    background-size: 28rpx
                    border-radius: 50%
            // &:last-child
            //     width 28rpx
            //     background: url(./../../assets/images/home/close.png) no-repeat
            //     background-size: 100%
    .van-grid
        height calc(100% - 15rpx)
        background url(./../../assets/images/home/bg.png) center no-repeat
        background-size: 100% 100%
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        padding 30rpx 12rpx !important
        position relative
        z-index 2
        align-items flex-start
        align-content flex-start
        margin 0 15rpx
        box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
        border-radius: 16rpx;
        &.noneMenu
            background url(./../../assets/images/common/no_data.png) center no-repeat, #fff
            background-size: 88% auto
        .refresh
            height: 30rpx
            border none
            border-radius: 15rpx
            background: linear-gradient( 90deg, #F70007 0%, #FF5254 100%);
            font-size 14rpx
            color #fff
            position absolute
            right 20rpx;
            top 20rpx;
        .van-grid-item
            padding-right 0!important
            .van-grid-item__content
                border none
                padding 0
                background-color transparent
                img
                    width 64rpx
                    height 64rpx
                    margin-right -12rpx
                p
                    margin 0
                    font-size 14rpx
                    margin-top 6rpx
                    width 85%
                    text-align center
</style>
